import React from 'react';
import { Grid, Box, Typography, LinearProgress } from '@mui/material';
import { useStatusBarStore } from 'stores';
import { BreathingSparkAnimation } from 'components/Animations';

function RunningSparkSubHeader() {
  const percentageComplete = useStatusBarStore(
    (state) => state.percentageComplete
  );

  return (
    <Grid
      item
      display={'flex'}
      width={'100%'}
      height={'4rem'}
      bgcolor={'white'}
      justifyContent={'space-between'}
      alignItems={'center'}
    >
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        gap={2}
        paddingLeft={2}
      >
        <BreathingSparkAnimation width={40} height={40} />
        <Typography>Running Spark</Typography>
      </Box>
      <Box width={'15%'} paddingRight={5}>
        <LinearProgress
          sx={{ height: '8px', borderRadius: '10px' }}
          variant='determinate'
          value={percentageComplete}
        />
      </Box>
    </Grid>
  );
}

export default RunningSparkSubHeader;
